import type catalogEn from "./catalog.en";

const catalogAr: Record<keyof typeof catalogEn, string> = {
  "products.title": "المنتجات",
  "products.add": "إضافة منتج",
  "products.import": "استيراد",
  "products.export": "تصدير",
  "products.tab.all": "الكل",
  "products.tab.active": "نشطة",
  "products.tab.draft": "مسودات",
  "products.tab.archived": "مؤرشفة",
  "products.search": "ابحث بالاسم أو رمز SKU",
  "products.filter.vendor": "المورّد",
  "products.filter.type": "النوع",
  "products.filter.tag": "الوسم",
  "products.filter.clear": "مسح",
  "products.filter.clear_all": "مسح الكل",
  "products.filter.any": "الكل",
  "products.sort": "الترتيب",
  "products.sort.-updated_at": "آخر تحديث (الأحدث أولاً)",
  "products.sort.-created_at": "تاريخ الإنشاء (الأحدث أولاً)",
  "products.sort.created_at": "تاريخ الإنشاء (الأقدم أولاً)",
  "products.sort.title": "اسم المنتج من أ إلى ي",
  "products.sort.-title": "اسم المنتج من ي إلى أ",
  "products.col.product": "المنتج",
  "products.col.status": "الحالة",
  "products.col.variants": "الخيارات",
  "products.col.price": "السعر",
  "products.col.vendor": "المورّد",
  "products.variants_count": "{n} خيارات",
  "products.empty_title": "أضف منتجك الأول",
  "products.empty_body": "المنتجات هي ما تبيعه. أضف منتجاً، أو استورد كتالوجك من منصة أخرى أو من جدول بيانات.",
  "products.none_match": "لا توجد منتجات مطابقة لهذه الفلاتر.",
  "products.selected": "تم تحديد {n}",
  "products.select_all_matching": "تحديد جميع المنتجات المطابقة",
  "products.all_matching_selected": "تم تحديد جميع المنتجات المطابقة.",
  "products.bulk.add_tags": "إضافة وسوم",
  "products.bulk.remove_tags": "إزالة وسوم",
  "products.bulk.active": "تعيين كنشط",
  "products.bulk.draft": "تعيين كمسودة",
  "products.bulk.archived": "أرشفة",
  "products.bulk.publish": "النشر في واجهة المتجر",
  "products.bulk.unpublish": "الإخفاء من واجهة المتجر",
  "products.bulk.delete": "حذف",
  "products.bulk.delete_confirm": "حذف {n} منتجات؟ تحتفظ الطلبات بسجلها.",
  "products.bulk.tags_prompt": "الوسوم (مفصولة بفواصل)",
  "products.bulk.done": "تم تحديث {n} منتجات.",
  "products.bulk.started": "جارٍ التنفيذ في الخلفية.",
  "products.load_more": "عرض المزيد",
  "status.active": "نشط",
  "status.draft": "مسودة",
  "status.archived": "مؤرشف",
  "status.unlisted": "غير مدرج",
  "product.new": "إضافة منتج",
  "product.title": "الاسم",
  "product.title_placeholder": "قميص بأكمام قصيرة",
  "product.description": "الوصف",
  "product.media": "الوسائط",
  "product.media_add": "إضافة صور أو فيديو",
  "product.media_drop": "أفلت الملفات هنا",
  "product.media_video": "إضافة رابط فيديو",
  "product.media_video_prompt": "رابط YouTube أو Vimeo",
  "product.media_alt": "النص البديل",
  "product.media_save_first": "احفظ المنتج لإضافة الوسائط.",
  "product.pricing": "التسعير",
  "product.price": "السعر",
  "product.compare_at": "السعر قبل الخصم",
  "product.cost": "التكلفة لكل قطعة",
  "product.cost_hint": "لن يراها العملاء.",
  "product.margin": "هامش الربح",
  "product.profit": "الربح",
  "product.charge_tax": "تطبيق الضريبة على هذا المنتج",
  "product.inventory": "المخزون",
  "product.inventory_soon": "المخزون حسب الموقع متاح مع تتبع المخزون.",
  "product.sku": "رمز SKU",
  "product.barcode": "الباركود",
  "product.continue_selling": "متابعة البيع عند نفاد المخزون",
  "product.shipping": "الشحن",
  "product.physical": "هذا منتج مادي",
  "product.weight": "الوزن",
  "product.hs_code": "رمز النظام المنسق",
  "product.origin": "بلد/منطقة المنشأ",
  "product.variants": "الخيارات",
  "product.add_options": "أضف خيارات مثل المقاس أو اللون",
  "product.option_name": "اسم الخيار",
  "product.option_values": "القيم",
  "product.option_value_placeholder": "أضف قيمة أخرى",
  "product.add_option": "إضافة خيار آخر",
  "product.remove_option": "إزالة الخيار",
  "product.done": "تم",
  "product.variant": "الخيار",
  "product.no_variants": "أضف قيمًا لإنشاء الخيارات.",
  "product.seo": "الظهور في محركات البحث",
  "product.seo_title": "عنوان الصفحة",
  "product.seo_description": "الوصف التعريفي",
  "product.seo_handle": "رابط الصفحة",
  "product.status": "الحالة",
  "product.online_store": "واجهة المتجر",
  "product.published": "ظاهر في واجهة المتجر",
  "product.schedule": "جدولة النشر",
  "product.organization": "تنظيم المنتج",
  "product.category": "الفئة",
  "product.category_search": "ابحث في الفئات",
  "product.type": "النوع",
  "product.vendor": "المورّد",
  "product.collections": "المجموعات",
  "product.tags": "الوسوم",
  "product.tags_hint": "اضغط Enter لإضافة وسم",
  "product.template": "قالب العرض",
  "product.gift_card": "هذه بطاقة هدية",
  "product.metafields": "الحقول المخصصة",
  "product.metafields_none": "لا توجد تعريفات حقول مخصصة بعد. أضفها من الإعدادات ← الحقول المخصصة.",
  "product.duplicate": "نسخ",
  "product.view": "عرض في المتجر",
  "product.delete": "حذف المنتج",
  "product.delete_confirm": "حذف {title}؟ لا يمكن التراجع، لكن الطلبات تحتفظ بسجلها.",
  "product.saved": "تم حفظ المنتج",
  "product.created": "تم إنشاء المنتج",
  "product.conflict": "غيّر شخص آخر هذا المنتج. أعد التحميل لرؤية التغييرات.",
  "product.unsaved_new": "منتج غير محفوظ",
  "collections.title": "المجموعات",
  "collections.add": "إنشاء مجموعة",
  "collections.empty_title": "نظّم منتجاتك في مجموعات",
  "collections.empty_body": "تساعد المجموعات العملاء على إيجاد المنتجات حسب الفئة أو الموسم أو العروض.",
  "collections.col.products": "المنتجات",
  "collections.col.conditions": "الشروط",
  "collections.type": "نوع المجموعة",
  "collections.manual": "يدوية",
  "collections.manual_hint": "أضف المنتجات واحدًا تلو الآخر.",
  "collections.smart": "تلقائية",
  "collections.smart_hint": "تُضاف المنتجات المطابقة للشروط تلقائيًا.",
  "collections.conditions": "الشروط",
  "collections.match_all": "كل الشروط",
  "collections.match_any": "أي شرط",
  "collections.match": "يجب أن تطابق المنتجات:",
  "collections.add_condition": "إضافة شرط آخر",
  "collections.products": "المنتجات",
  "collections.browse": "تصفح المنتجات",
  "collections.sort": "الترتيب",
  "collections.sort.manual": "يدويًا",
  "collections.sort.best_selling": "الأكثر مبيعًا",
  "collections.sort.title_asc": "الاسم من أ إلى ي",
  "collections.sort.title_desc": "الاسم من ي إلى أ",
  "collections.sort.price_asc": "الأقل سعرًا",
  "collections.sort.price_desc": "الأعلى سعرًا",
  "collections.sort.created_desc": "الأحدث",
  "collections.sort.created_asc": "الأقدم",
  "collections.no_products": "لا توجد منتجات في هذه المجموعة بعد.",
  "collections.delete_confirm": "حذف {title}؟ تبقى المنتجات في متجرك.",
  "collections.pick": "إضافة منتجات",
  "rule.title": "اسم المنتج",
  "rule.type": "نوع المنتج",
  "rule.vendor": "مورّد المنتج",
  "rule.tag": "وسم المنتج",
  "rule.price": "السعر",
  "rule.compare_at_price": "السعر قبل الخصم",
  "rule.weight": "الوزن (كغ)",
  "rule.variant_title": "اسم الخيار",
  "rule.metafield": "حقل مخصص",
  "rel.equals": "يساوي",
  "rel.not_equals": "لا يساوي",
  "rel.contains": "يحتوي على",
  "rel.not_contains": "لا يحتوي على",
  "rel.starts_with": "يبدأ بـ",
  "rel.ends_with": "ينتهي بـ",
  "rel.greater_than": "أكبر من",
  "rel.less_than": "أقل من",
  "rel.is_empty": "فارغ",
  "rel.is_not_empty": "غير فارغ",
  "import.title": "استيراد المنتجات من ملف CSV",
  "import.hint": "ارفع ملف CSV للمنتجات بصيغة التصدير المعتادة في معظم منصات التجارة الإلكترونية. تُجلب الصور من روابطها.",
  "import.choose": "اختر ملف CSV",
  "import.preview": "معاينة",
  "import.rows": "{rows} صفوف، {products} منتجات",
  "import.unmapped": "أعمدة متجاهلة",
  "import.update_existing": "استبدال المنتجات التي لها الرابط نفسه",
  "import.start": "استيراد المنتجات",
  "import.running": "جارٍ الاستيراد… {done} من {total}",
  "import.done": "اكتمل الاستيراد",
  "import.summary": "أُنشئ {created}، حُدّث {updated}، تُخطّي {skipped}، فشل {failed}",
  "import.errors": "المشكلات",
  "import.download_errors": "تنزيل تقرير الأخطاء",
  "import.sample": "تنزيل ملف CSV نموذجي",
  "export.title": "تصدير المنتجات",
  "export.scope": "التصدير",
  "export.all": "جميع المنتجات",
  "export.filtered": "المنتجات المطابقة للبحث والفلاتر",
  "export.selected": "{n} منتجات محددة",
  "export.excel": "ملف CSV لبرنامج Excel (يحافظ على النص العربي)",
  "export.plain": "ملف CSV عادي",
  "export.start": "تصدير المنتجات",
  "export.running": "جارٍ التصدير… {done} من {total}",
  "export.ready": "ملف التصدير جاهز.",
  "export.download": "تنزيل",
  "job.failed": "حدث خطأ: {error}",
  "custom.title": "الحقول المخصصة",
  "custom.hint": "أضف حقولًا إلى المنتجات والخيارات والمجموعات، وأنشئ أنواع محتوى مثل المصممين أو جداول المقاسات.",
  "custom.definitions_for": "الحقول المخصصة لـ {owner}",
  "custom.owner.product": "المنتجات",
  "custom.owner.variant": "الخيارات",
  "custom.owner.collection": "المجموعات",
  "custom.add_definition": "إضافة تعريف",
  "custom.name": "الاسم",
  "custom.namespace_key": "النطاق والمفتاح",
  "custom.type": "النوع",
  "custom.description": "الوصف",
  "custom.choices": "القيم المسموح بها (قيمة في كل سطر)",
  "custom.storefront": "إتاحته للقوالب في واجهة المتجر",
  "custom.delete_definition": "حذف التعريف",
  "custom.delete_definition_confirm": "حذف {name}؟ تبقى القيم المحفوظة كحقول غير منظمة.",
  "custom.metaobjects": "أنواع المحتوى",
  "custom.add_metaobject_type": "إضافة تعريف",
  "custom.entries": "{n} إدخالات",
  "custom.fields": "الحقول",
  "custom.add_field": "إضافة حقل",
  "custom.field_key": "المفتاح",
  "custom.required": "إلزامي",
  "custom.display_name": "حقل الاسم المعروض",
  "custom.open_entries": "إدارة الإدخالات",
  "custom.add_entry": "إضافة إدخال",
  "custom.handle": "الرابط",
  "custom.no_entries": "لا توجد إدخالات بعد.",
  "type.single_line_text": "نص من سطر واحد",
  "type.multi_line_text": "نص متعدد الأسطر",
  "type.number_integer": "عدد صحيح",
  "type.number_decimal": "عدد عشري",
  "type.boolean": "صح أو خطأ",
  "type.date": "تاريخ",
  "type.date_time": "تاريخ ووقت",
  "type.url": "رابط",
  "type.color": "لون",
  "type.money": "مبلغ مالي",
  "type.weight": "وزن",
  "type.dimension": "بُعد",
  "type.volume": "حجم",
  "type.rating": "تقييم",
  "type.json": "JSON",
  "type.file_reference": "ملف",
  "type.product_reference": "منتج",
  "type.variant_reference": "خيار منتج",
  "type.collection_reference": "مجموعة",
  "type.metaobject_reference": "إدخال محتوى",
  "type.list": "قائمة من {type}",
  "products.sort.updated_at": "آخر تحديث (الأقدم أولاً)",
  "products.sort.inventory": "المخزون (من الأقل للأعلى)",
  "products.sort.-inventory": "المخزون (من الأعلى للأقل)",
  "products.sort.product_type": "نوع المنتج من أ إلى ي",
  "products.sort.-product_type": "نوع المنتج من ي إلى أ",
  "products.sort.vendor": "المورّد من أ إلى ي",
  "products.sort.-vendor": "المورّد من ي إلى أ",
  "products.col.inventory": "المخزون",
  "products.col.category": "الفئة",
  "products.inv.untracked": "المخزون غير متتبَّع",
  "products.inv.in_stock": "{n} في المخزون",
  "products.inv.for_variants": "{n} في المخزون لـ {v} خيارات",
  "products.filter.collection": "المجموعة",
  "products.bulk.more": "إجراءات أخرى",
  "products.bulk.add_collections": "إضافة إلى مجموعات",
  "products.bulk.remove_collections": "إزالة من مجموعات",
  "products.bulk.add_tags_title": "إضافة وسوم إلى {n} منتجات",
  "products.bulk.remove_tags_title": "إزالة وسوم من {n} منتجات",
  "products.bulk.add_tags_hint": "اكتب وسماً واضغط Enter. تظهر الوسوم الموجودة كاقتراحات.",
  "products.bulk.remove_tags_hint": "المنتجات التي لا تحمل هذه الوسوم تبقى كما هي.",
  "products.bulk.add_collections_title": "إضافة {n} منتجات إلى مجموعات",
  "products.bulk.remove_collections_title": "إزالة {n} منتجات من مجموعات",
  "products.bulk.no_manual_collections": "لا توجد مجموعات يدوية بعد. المجموعات الذكية تختار المنتجات حسب شروطها.",
  "product.quantity": "الكمية",
  "product.has_sku": "لهذا المنتج رمز SKU أو باركود",
  "product.barcode_hint": "ISBN أو UPC أو GTIN وغيرها",
  "product.hs_code_hint": "رمز النظام المنسق المستخدم في الجمارك",
  "product.media_alt_hint": "صف الصورة للعملاء الذين يستخدمون قارئات الشاشة.",
  "product.variants_total": "{n} خيارات · إجمالي المخزون: {total} متاح",
  "product.options": "الخيارات",
  "product.variant_saved": "تم حفظ الخيار",
  "product.variant_missing": "هذا الخيار لم يعد موجوداً.",
  "product.variant_image": "صورة الخيار",
  "product.variant_delete": "حذف الخيار",
  "product.variant_delete_confirm": "حذف {title}؟ سيتم شطب مخزونه.",
  "rule.category": "فئة المنتج",
  "rule.inventory_stock": "مخزون المنتج",
};

export default catalogAr;
